<script setup lang="ts">
import {nextTick, onBeforeMount, watch} from "vue";
import {debug, loadBT, loading, queryParams, bsModalState} from "@/store/bt";
import SpinnerIcon from "@/icons/SpinnerIcon.vue";
import BTMainContent from "@/bt/BTMainContent.vue";
import {useBootstrapModalListeners} from "@/composables/useBootstrapModalListeners";

const {initModalEventListeners, preventSidebarDuplicateOnPC} = useBootstrapModalListeners()

const nid = (window as any).drupalSettings?.matrixNodeId || document.querySelector('article')?.getAttribute('data-history-node-id') as string
const title = document.querySelector('h1')?.textContent as string

watch(queryParams, () => {
  // Append selection the query string
  const queryString = new URLSearchParams(window.location.search)
  queryString.set('benefit', queryParams.benefit.toString())
  queryString.set('sector', queryParams.sector.toString())
  queryString.set('multiDisplay', queryParams.multiDisplay.toString())
  window.history.replaceState(null, '', `${window.location.pathname}?${queryString.toString()}`)
})

onBeforeMount(async () => {
  const queryString = new URLSearchParams(window.location.search)
  if (queryString.has('benefit')) {
    queryParams.benefit = parseInt(queryString.get('benefit') as string)
  }
  if (queryString.has('sector')) {
    queryParams.sector = parseInt(queryString.get('sector') as string)
  }
  if (queryString.has('multiDisplay')) {
    queryParams.multiDisplay = queryString.get('multiDisplay') === 'true'
  }
  if (queryString.has('debug')) {
    debug.value = true
  }
  await loadBT(nid, queryParams);
  await nextTick(() => {
    initModalEventListeners('btFullScreenModal', bsModalState)
    preventSidebarDuplicateOnPC(bsModalState)
  })
})
</script>

<template>
  <div v-if="loading">
    <div class="bt__loader">
      <SpinnerIcon/>
    </div>
  </div>
  <template v-if="!loading">
    <div class="modal fade hidden" id="btFullScreenModal" tabindex="-1"
         aria-labelledby="btFullScreenModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header pe-4">
            <h1 class="modal-title fs-4" id="btFullScreenModalLabel">{{ title }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="p-4 bg-white">
            <BTMainContent v-if="bsModalState"/>
          </div>
          <div class="modal-footer pe-4 bg-white">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <BTMainContent v-if="!bsModalState"/>
  </template>
</template>

<style scoped>
.bt__loader {
  display: grid;
  place-items: center;
  min-height: 500px;
}
</style>
